import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { ServiceCarrito } from './home.service';
import { NgForm } from '@angular/forms';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Location, PopStateEvent } from '@angular/common';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';


@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})




export class HomeComponent implements OnInit {
    model = {
        left: true,
        middle: false,
        right: false
    };
    closeResult: string;

    focus;
    focus1;
    public isCollapsed = true;
    private lastPoppedUrl: string;
    private yScrollStack: number[] = [];


    @ViewChild('formident',{static: true})formident: NgForm; 
    @ViewChild('formpro',{static: true}) formpro: NgForm;
    
    onSubmitContacto(){

      this.contacto.name = this.formpro.value.name;
      this.contacto.email = this.formpro.value.email;
      this.contacto.message = this.formpro.value.message;  
      this.formpro.reset();
      let nombre = JSON.stringify(this.contacto.name);
      let correo = JSON.stringify(this.contacto.email);
      let mensaje = JSON.stringify(this.contacto.message);
      window.open('mailto:carreras.unsl@gmail.com?subject=Consulta%20Promocion%20Carreras%202021&body=Nombre%20completo:'+nombre+' Correo: '+correo+' Mensaje: '+mensaje);
      
      
      
      } 

    carreras: any;
    carreraBus: any;
    
    //cambio a checkbox
    tipoCheck: any;
    duracionCheck: any;
    sedeCheck: any;
    contacto:any;
    //-----------------
    public carrerasSeleccionadas: any;
      constructor( private serviceCarrito: ServiceCarrito, private modalService: NgbModal, private router:Router, private location:Location) {
        this.carreraBus = {
          tipo:'',
          duracion:'',
          sede: ''      
        };
        this.contacto = {
          name: '',
          email: '',
          message: '',
          }
        //-------------------------- carga vacio en el constructor
        this.tipoCheck = {};
        this.duracionCheck  ={};
        this.sedeCheck = {};   
        //--------------------------
       }
      
      getCarreras(){
        return this.carrerasSeleccionadas;
        //return this.carreras;
      }
       
      ngOnInit() {
        this.carreras = this.serviceCarrito.getCarreras( );        
        
          this.router.events.subscribe((event) => {
            this.isCollapsed = true;
            if (event instanceof NavigationStart) {
               if (event.url != this.lastPoppedUrl)
                   this.yScrollStack.push(window.scrollY);
           } else if (event instanceof NavigationEnd) {
               if (event.url == this.lastPoppedUrl) {
                   this.lastPoppedUrl = undefined;
                   window.scrollTo(0, this.yScrollStack.pop());
               } else
                   window.scrollTo(0, 0);
           }
         });
         this.location.subscribe((ev:PopStateEvent) => {
             this.lastPoppedUrl = ev.url;
         });
        }
        
           
      
      /*onSubmit2(){
        document.getElementById('tablaCarreraNull').style.display = 'none';
        document.getElementById('tablaCarrera').style.display = 'none';
        this.carrerasSeleccionadas =[Array];
        let i = 0;
        let carreras = this.carreras;       
        this.carreraBus.tipo = this.formident.value.tipo;
        this.carreraBus.duracion = this.formident.value.duracion;
        this.carreraBus.sede = this.formident.value.sede;  
        
        for (let index = 0; index < carreras.length; index++) {
          const element = carreras[index];
          if((this.carreraBus.tipo == element.tipo) || (this.carreraBus.duracion == element.duracion) || (this.carreraBus.sede == element.sede)){
            this.carrerasSeleccionadas[i] = element;
            i++;
          }
        }
        if (this.carrerasSeleccionadas[0] == "function Array() { [native code] }") {
          document.getElementById('tablaCarreraNull').style.display = 'table';
        }else{
          document.getElementById('tablaCarrera').style.display = 'table';      
        }
        
      }*/
      onSubmit(){        
        //document.getElementById('tablaCarreraNull').style.display = 'none';
        //document.getElementById('tablaCarrera').style.display = 'none';
        this.carrerasSeleccionadas =[Array];
        let i = 0;
        let carreras = this.carreras;
        let listaTipo = getCheckedCheckboxesFor("tipo");
        let listaduracion = getCheckedCheckboxesFor("duracion");
        let listasede = getCheckedCheckboxesFor("sede");     
        //tipo
        if(listaTipo.length != 0 && listasede.length == 0 && listaduracion.length == 0){
          i=0;      
          for (let indice = 0; indice < listaTipo.length; indice++){
            for (let index = 0; index < carreras.length; index++) {          
              if(listaTipo[indice] == carreras[index].tipo){
                this.carrerasSeleccionadas[i] = carreras[index];
                i++;
              }
            }
          } 
        }
        //duracion
        if(listaduracion.length != 0 && listasede.length == 0 && listaTipo.length == 0){
          i=0;      
          for (let indice = 0; indice < listaduracion.length; indice++){
            for (let index = 0; index < carreras.length; index++) {          
              if(listaduracion[indice] == carreras[index].duracion){
                this.carrerasSeleccionadas[i] = carreras[index];
                i++;
              }
            }
          } 
        }
        //sede
        if(listasede.length != 0 && listaduracion.length == 0 && listaTipo.length == 0){
          i=0;      
          for (let indice = 0; indice < listasede.length; indice++){
            for (let index = 0; index < carreras.length; index++) {          
              if(listasede[indice] == carreras[index].sede){
                this.carrerasSeleccionadas[i] = carreras[index];
                i++;
              }
            }
          } 
        }
        //sedexduracion
        if(listasede.length != 0 && listaduracion.length != 0 && listaTipo.length == 0){
          i=0;      
          for (let indice = 0; indice < listasede.length; indice++){
            for (let indicador = 0; indicador < listaduracion.length; indicador++) {          
              for (let index = 0; index < carreras.length; index++) {          
                if(listasede[indice] == carreras[index].sede && listaduracion[indicador] == carreras[index].duracion){              
                  this.carrerasSeleccionadas[i] = carreras[index];
                  i++;              
                }
              }
            }
          } 
        }
        //sedextipo
        if(listasede.length != 0 && listaduracion.length == 0 && listaTipo.length != 0){
          i=0;      
          for (let indice = 0; indice < listaTipo.length; indice++){
            for (let indicador = 0; indicador < listasede.length; indicador++) {          
              for (let index = 0; index < carreras.length; index++) {          
                if(listaTipo[indice] == carreras[index].tipo && listasede[indicador] == carreras[index].sede){              
                  this.carrerasSeleccionadas[i] = carreras[index];
                  i++;              
                }
              }
            }
          } 
        }
        //tipoxduracion
        if(listasede.length == 0 && listaduracion.length != 0 && listaTipo.length != 0){
          i=0;      
          for (let indice = 0; indice < listaTipo.length; indice++){
            for (let indicador = 0; indicador < listaduracion.length; indicador++) {          
              for (let index = 0; index < carreras.length; index++) {          
                if(listaTipo[indice] == carreras[index].tipo && listaduracion[indicador] == carreras[index].duracion){              
                  this.carrerasSeleccionadas[i] = carreras[index];
                  i++;              
                }
              }
            }
          } 
        }
        //sedexduracionxtipo
        if(listasede.length != 0 && listaduracion.length != 0 && listaTipo.length != 0){
          i=0;      
          for (let indice = 0; indice < listaTipo.length; indice++){
            for (let indicador = 0; indicador < listasede.length; indicador++) {          
              for (let indice2 = 0; indice2 < listaduracion.length; indice2++){          
                for (let index = 0; index < carreras.length; index++) {          
                  if(listaTipo[indice] == carreras[index].tipo && listasede[indicador] == carreras[index].sede && listaduracion[indice2] == carreras[index].duracion){              
                    this.carrerasSeleccionadas[i] = carreras[index];
                    i++;              
                  }
                }
              }
            }
          } 
        }
        function getCheckedCheckboxesFor(checkboxName) {
          var checkboxes = document.querySelectorAll('input[name="' + checkboxName + '"]:checked'), values = [];
          Array.prototype.forEach.call(checkboxes, function(el) {
              values.push(el.value);
          });
          return values;
      }
      }
      open(content, type, modalDimension) {
        if (modalDimension === 'sm' && type === 'modal_mini') {
            this.modalService.open(content, { windowClass: 'modal-mini', size: 'sm', centered: true }).result.then((result) => {
                this.closeResult = `Closed with: ${result}`;
            }, (reason) => {
                this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
            });
        } else if (modalDimension === '' && type === 'Notification') {
          this.modalService.open(content, { windowClass: 'modal-danger', centered: true }).result.then((result) => {
              this.closeResult = `Closed with: ${result}`;
          }, (reason) => {
              this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
          });
        } else {
            this.modalService.open(content,{ centered: true }).result.then((result) => {
                this.closeResult = `Closed with: ${result}`;
            }, (reason) => {
                this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
            });
        }
    }
    private getDismissReason(reason: any): string {
      if (reason === ModalDismissReasons.ESC) {
          return 'by pressing ESC';
      } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
          return 'by clicking on a backdrop';
      } else {
          return  `with: ${reason}`;
      }
  }
    
}
